<template>
  <modal
    ref="modalComponent"
    size="xl"
    :show="show"
    @hidden="$emit('hidden', false)"
    :hide-footer="true"
    :minimization-config="minimizationConfig"
    :modal-data="modalData"
    :scrollable="false"
    header-class="flex-grow-1"
    modal-class="kr-activity-modal"
  >
    <div class="d-flex align-items-center" slot="minimizedView">
      <i class="kr-icon mt-1 flex-shrink-0"></i>
      <span class="ml-2 text-truncate" v-no-capture>{{ kr.title }}</span>
    </div>
    <kr-row
      class="px-0 kr-row"
      view-type="detail"
      avatar-size="40"
      :kr="kr"
      :orgId="kr.organizationId"
      :show-details-page-navigator="false"
      :goalId="kr.goalId"
      :source="source"
      :draggable="false"
      :selectable="false"
      :show-options-menu="false"
      :edit-on-load="editOnLoad"
      :show-checkin-button="false"
    />
    <kr-activities :kr-id="krId" :collapse-checkin="!showCheckin" :source="source" />
  </modal>
</template>

<script>
import KrActivities from '@/components/kr/KrActivities'
import Modal from '@/components/Modal'
import { ENTITY_TYPE } from '@/constants/entities'
import { addToHistory } from '@/history'
import resolveRoute from '@/router/resolveRoute'
import { getKrPageRouteConfig } from '@/utils/navigationConfigs'

/**
 * This component shows KR Activity and gives an option to perform Checkin into KR
 *
 * props:
 *  - kr
 *  - showCheckin: whether to keep the checkin form visible on load
 *  - show
 */
export default {
  name: 'KrActivityModal',
  props: {
    show: Boolean,
    krId: [Number, String],
    modalData: { default: () => ({}) },
    showCheckin: Boolean,
    /**
     * location from where modal is opened
     */
    source: String,
    editOnLoad: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'show'
  },
  data() {
    return {
      minimizationConfig: {
        type: ENTITY_TYPE.KEY_RESULT
      }
    }
  },
  components: {
    Modal,
    KrActivities,
    KrRow: () => import('@/components/KrRow.vue')
  },
  computed: {
    kr() {
      return this.$store.getters.keyResultById(this.krId)
    },
    goal() {
      return this.$store.getters.goalById(this.kr.goalId)
    }
  },
  methods: {
    saveVisit() {
      const route = getKrPageRouteConfig({
        krId: this.kr.id,
        orgId: this.kr.organizationId
      })
      const krRoute = resolveRoute(route).route
      const values = [
        ['krId', this.kr.id, this.kr.title],
        ['goalId', this.goal.id, this.goal.title]
      ]
      addToHistory({ ...krRoute, values })
    }
  },
  mounted() {
    this.saveVisit()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.goal-activity {
  padding-left: 7px;
}

.events-section {
  padding: 0 40px;
  display: block;
}

.chart {
  margin-top: 24px;
  margin-bottom: 32px;
}

.chart,
/deep/ .chart canvas {
  height: 150px !important;
}

.kr-icon {
  @include dimension(16px, 19px);
  background-size: contain;
  margin: 5px 10px;
}

.progress-indicator {
  margin-right: 65px;
}

/deep/ .tab-content {
  padding: 0 24px;
}
</style>

<style lang="scss">
@import '~@/styles/_styleConfigurations.scss';

$sideGutter: 110px;

@include media-breakpoint-up(xl) {
  .kr-activity-modal {
    .modal-header {
      padding: 25px $sideGutter 10px $sideGutter;
    }

    .modal-body {
      padding-left: $sideGutter;
      padding-right: $sideGutter;
    }

    .progress-indicator {
      margin-right: 10px;
    }
  }
}

.kr-row {
  margin: -8px -40px 40px !important;
}

@include media-breakpoint-down(lg) {
  .kr-activity-modal {
    .modal-header {
      padding-top: 25px;
    }
  }
}
</style>
